import React from "react";
import SponsorForm from "../components/Sponsor/BecomeASponsor/SponsorForm";
import MainLayouts from "../layout/MainLayouts";
export default function BecomeASposor() {

  return (
    <MainLayouts>
      <SponsorForm />
    </MainLayouts>
  );
}
